import {preregistro} from './siteActions/preregistro'

export let actions = {
  preregistro
}



// WEBPACK FOOTER //
// ./src/impuestos/siteActions.js